import {useEffect,useRef,useState,type ReactNode} from 'react';
import {RoomEvent,type Room,type Participant} from 'livekit-client';
import './participant-grid.css';

export function ParticipantGrid({room,participants,strip=false,renderTile}:{room:Room|null;participants:Participant[];strip?:boolean;renderTile:(person:Participant)=>ReactNode}) {
  const [speaker,setSpeaker]=useState('');
  const current=useRef('');
  useEffect(()=>{
    if(!room)return;
    let timer:ReturnType<typeof setTimeout>|undefined;
    const update=(speakers:Participant[])=>{
      clearTimeout(timer);
      const next=speakers[0]?.identity || '';
      if(next===current.current)return;
      timer=setTimeout(()=>{current.current=next;setSpeaker(next);},next?300:1500);
    };
    room.on(RoomEvent.ActiveSpeakersChanged,update);update(room.activeSpeakers || []);
    return()=>{clearTimeout(timer);room.off(RoomEvent.ActiveSpeakersChanged,update);};
  },[room]);
  const chosen=participants.find(person=>person.identity===speaker);
  return <div className={`call-grid participant-grid${strip?' call-grid--strip participant-grid--strip':''}${chosen&&participants.length>1?' participant-grid--speaker':''}`} data-participants={participants.length}>
    {participants.map(person=><div key={person.identity} className={`participant-grid-item${person===chosen?' participant-grid-item--speaker':''}`} data-participant={person.identity}>
      {renderTile(person)}
      {person===chosen&&<span className="participant-speaking" aria-label={`Говорит ${person.name||'Участник'}`}>Говорит</span>}
    </div>)}
  </div>;
}
